import { Http } from '@/services/http';
import { Token, Cookie } from '@/utils';

export const auth = {

    namespaced: true,

    state:
    {
        accessToken: null,
        refreshToken: null,
        accessUser: {
            firstname: 'Jemuel',
            lastname: 'Acuna',
            photo: '',
            date_registered: '2019-01-01 01:00:00',
            user:
            {
                username: 'master@vantagehunt.com',
                user_type:
                {
                    id: 1,
                    name: 'System Administrator',
                    is_enabled: 1
                },
            }
        },
        isActive: false,
        isProcessing: false,
    },

    mutations:
    {
        setTokens: (state, { accessToken, refreshToken }) =>
        {
            state.isActive = true;
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
        },

        setUser: (state, user) =>
        {
            state.accessUser = user;
        },

        setProcessing: (state, bool) =>
        {
            state.isProcessing = bool;
        },

        resetState: (state) =>
        {
            state.isActive = false;
            state.accessUser = {};
            state.accessToken = null;
            state.refreshToken = null;
        },
    },

    actions:
    {
        signin: async ({ dispatch }, form) =>
        {
            const response = await Http.post('/login', form);

            if (response.status === 200)
            {
                Token.set(response.data);
                
                dispatch('getUser');
            }

            return response;
        },

        signout: async ({ commit }) =>
        {
            const response = await Http.get('/logout');

            if (response.status === 200)
            {
                commit('resetState');

                Token.destroy();
            }

            return response;
        },

        forceSignout: ({ commit }) =>
        {
            Token.destroy();

            commit('resetState');
        },

        getUser: async ({ commit }) =>
        {
            commit('setProcessing', true);

            const response = await Http.get('/my-account');

            if (response.status === 200)
            {
                commit(
                    'setTokens',
                    {
                        accessToken: Cookie.get(process.env.ACCESS_TOKEN),
                        refreshToken: Cookie.get(process.env.REFRESH_TOKEN),
                    }
                );
                commit('setUser', response.data);
            }

            commit('setProcessing', false);

            return response;
        },

        updateUser: async ({ commit }, user) =>
        {
            commit('setUser', user);
        },

        manage: async ({ dispatch }, form) =>
        {
            const response = await Http.post(
                '/account/manage',
                form
            );

            if (response.status === 200)
            {
                Token.set(response.data);

                dispatch('getUser');
            }

            return response;
        },

        unset: ({ commit }) =>
        {
            commit('resetState');
        },
    },

    getters:
    {
        accessUser: state => state.accessUser,

        isProcessing: state => state.isProcessing,

        isActive: state => state.isActive,
    },
};



// WEBPACK FOOTER //
// ./src/views/auth/store.js